import { Link } from "react-router-dom";
import moment from "moment";
import styles from "./ListRecord.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import { AlertCircle, Bell, ChevronDown, ChevronUp, Code } from "react-feather";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: 13,
  },
}));

const ListRecords = ({ filterredData, initiateVoiceCall, history, sortItem, sortOrder, setSortItem, setSortOrder }) => {


  const changeSortOrder = (type) => {
    if (type === sortItem) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortOrder("asc");
    }
    setSortItem(type);
  }

  const getSlaTooltipData = (item) => {
    let txt = "Salary - N/A";
    let txt2 = "";
    if (item?.income_type === "Voucher") {
      txt = "Voucher - $" + item?.formatted_voucher_amount;
    } else if (item?.income_per_year !== "") {
      txt = "Salary - $" + item?.formatted_income_per_year;
    }

    if (item?.is_employement2 === 1) {
      if (item?.income_type2 === "Voucher" && item?.voucher_amount2 !== "") {
        txt2 = "Voucher2 - " + new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(item?.voucher_amount2);
      } else if (item?.income_per_year2 !== "") {
        txt2 = "Salary2 - " + new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(item?.income_per_year2);
      }
    }

    return (<div>
      {txt}
      <br />
      {txt2}
    </div>);
  }

  return (<>
    <div className={`${styles.IncomeListUnderSec}`}>
      <div className={`${styles.ListCardDivSec}`}>
        {filterredData.map((item, index) => {
          return (<Link to={"/people/prospects/details/" + item?.id}>
            <div className={`${styles.CardDivList}`}>
              <div className={`${styles.FirstSec} ${styles.ProfileImg}`}>
                {item?.user_avatar ? (<img src={item.user_avatar} alt={item.full_name} />) : (<div className={styles.ProNameIMG}>
                  <p>{item?.initial}</p>
                </div>)}
                <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                  <p className={`${styles.Name}`}>
                    {item?.full_name ? item?.full_name : "-"}
                  </p>
                  <p onClick={(e) => { e.preventDefault(); e.stopPropagation(); initiateVoiceCall(item); }} className={`${styles.Name}`}>{item?.phone}</p>
                </div>
              </div>
              <div className={`${styles.SecondSec}`}>
                <p className={`${styles.Name}`}>
                  Follow Up:{" "}
                  <span>
                    {item?.followup_date && <Bell />}
                    {item?.followup_date ? moment(item?.followup_date).format("MM/DD/YYYY") : " - "}
                  </span>
                </p>
                <p className={`${styles.Name}`}>
                  {item?.property_name}{" "}
                  {item?.apt_no ? "-" + item?.apt_no : null}
                </p>
              </div>
              <div className={`${styles.ThirdSec}`}>
                <div className={`${styles.ProsUserMandateSec}`}>
                  <Tooltip title={item?.credit_score !== "" ? "Credit Score - " + item?.credit_score : "Credit Score - N/A"}>
                    <span className={item?.check_list?.credit_score === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.credit_score === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                      <img src="/static/img/credit-score-icon.svg" alt="" />
                    </span>
                  </Tooltip>
                  <Tooltip title={getSlaTooltipData(item)}>
                    <span className={item?.check_list?.income === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.income === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                      <img src="/static/img/salary-icon.svg" alt="" />
                    </span>
                  </Tooltip>
                  <Tooltip title={item?.ever_had_bankruptcy !== "" ? "Bankruptcy - " + item?.ever_had_bankruptcy : "Bankruptcy - N/A"}>
                    <span className={item?.check_list?.bankruptcy === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.bankruptcy === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                      <img src="/static/img/bankruptcy-icon.svg" alt="" />
                    </span>
                  </Tooltip>
                  <Tooltip title={item?.ever_case_filed !== "" ? "Housing Court Cases - " + item?.ever_case_filed : "Housing Court Cases - N/A"}>
                    <span className={item?.check_list?.housing_court_case === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.housing_court_case === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                      <img src="/static/img/court-cases-icon.svg" alt="" />
                    </span>
                  </Tooltip>
                </div>
                <p className={`${styles.Name}`}>
                  Received :{" "}
                  <span>{moment.utc(item?.submitted_at).fromNow()}</span>
                  {item?.approval_remaining_days !== null && (item?.current_status !== 3 && item?.current_status !== 4) && <BootstrapTooltip title={(<div className={`${styles.IncomeLineTooltip}`}>
                    {item?.approval_remaining_days > 0 && <p>{item?.approval_remaining_days > 1 ? item?.approval_remaining_days + ' days ' : item?.approval_remaining_days + ' day '}remaining for approval.</p>}
                    {item?.approval_remaining_days <= 0 && <p>Approval Overdue ({Math.abs(item?.approval_remaining_days) + 1} days)</p>}
                  </div>)}>
                    <span className={`${styles.ProspectOverdueBadge}`}><AlertCircle /></span>
                  </BootstrapTooltip>}
                </p>
              </div>
              <div className={`${styles.FullSec}`}>
                <p className={`${styles.Name}`}>
                  Notes:{" "}
                  <span>{item?.followup_date ? item?.followup_note : "No Follow-Up Set"}</span>
                </p>
              </div>
            </div>
          </Link>);
        })}
      </div>

      <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={`${styles.TableHead}`} style={{ width: 180 }} onClick={(e) => changeSortOrder("full_name")}>
                Name
                {sortItem === "full_name" && sortOrder === "asc" && (
                  <ChevronDown />
                )}
                {sortItem === "full_name" && sortOrder === "desc" && (
                  <ChevronUp />
                )}
                {sortItem !== "full_name" && (
                  <Code className={`${styles.Normal}`} />
                )}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}>ELIGIBILITY</TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("followup_date")}>
                FOLLOW UP
                {sortItem === "followup_date" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "followup_date" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "followup_date" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 280 }}>NOTES</TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("property_name")}>
                PROPERTY
                {sortItem === "property_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "property_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "property_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>

              <TableCell className={`${styles.TableHead}`} style={{ width: 100 }} onClick={(e) => changeSortOrder("apt_no")}>
                APT NO
                {sortItem === "apt_no" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "apt_no" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "apt_no" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("submitted_date_str")}>
                RECEIVED
                {sortItem === "submitted_date_str" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "submitted_date_str" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "submitted_date_str" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterredData?.length > 0 && filterredData?.map((item, index) => {
              return (<div onClick={() => history.push("/people/prospects/details/" + item?.id)} className={`${styles.TableLink}`}>
                <TableRow key={index}>
                  <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg}`}>
                    <div className={`${styles.Inside}`}>
                      {item?.user_avatar ? (<img src={item?.user_avatar} alt="" />) : (<div className={`${styles.ProNameIMG}`}>
                        <p>{item?.initial}</p>
                      </div>)}

                      <div>
                        <p>{item?.full_name ? item?.full_name : "-"}</p>
                        <Tooltip title="Start a voice call">
                          <p className={`${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); initiateVoiceCall(item); }}>{item?.phone}</p>
                        </Tooltip>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>
                    <div className={`${styles.ProsUserMandateSec}`}>
                      <Tooltip title={item?.credit_score !== "" ? "Credit Score - " + item?.credit_score : "Credit Score - N/A"}>
                        <span className={item?.check_list?.credit_score === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.credit_score === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                          <img src="/static/img/credit-score-icon.svg" alt="" />
                        </span>
                      </Tooltip>
                      <Tooltip title={getSlaTooltipData(item)}>
                        <span className={item?.check_list?.income === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.income === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                          <img src="/static/img/salary-icon.svg" alt="" />
                        </span>
                      </Tooltip>
                      <Tooltip
                        title={item?.ever_had_bankruptcy !== "" ? "Bankruptcy - " + item?.ever_had_bankruptcy : "Bankruptcy - N/A"}>
                        <span className={item?.check_list?.bankruptcy === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.bankruptcy === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                          <img src="/static/img/bankruptcy-icon.svg" alt="" />
                        </span>
                      </Tooltip>
                      <Tooltip title={item?.ever_case_filed !== "" ? "Housing Court Cases - " + item?.ever_case_filed : "Housing Court Cases - N/A"}>
                        <span className={item?.check_list?.housing_court_case === 2 ? `${styles.MandateCheckSec} ${styles.Fail}` : item?.check_list?.housing_court_case === 1 ? `${styles.MandateCheckSec} ${styles.Active}` : `${styles.MandateCheckSec}`}>
                          <img src="/static/img/court-cases-icon.svg" alt="" />
                        </span>
                      </Tooltip>
                    </div>
                  </TableCell>
                  <TableCell className={moment(item.followup_date).isBefore(moment(), "day") ? `${styles.TableBodyText} ${styles.Icon} ${styles.Nowrap} ${styles.PastDate}` : `${styles.TableBodyText} ${styles.Icon} ${styles.Nowrap}`}>
                    {item?.followup_date && <Bell className={`${styles.Bell}`} />}
                    {item?.followup_date && <AlertCircle className={`${styles.Alert}`} />}
                    {item?.followup_date ? moment(item?.followup_date).format("MM/DD/YYYY") : " - "}
                  </TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>
                    <BootstrapTooltip title={<div className={`${styles.IncomeLineTooltip}`}>
                      <p>{item?.followup_date ? item?.followup_note : "No Follow-Up Set"}</p>
                    </div>}>
                      <div className={`${styles.FollowUpNotes}`}>{item?.followup_date ? item?.followup_note : "No Follow-Up Set"}</div>
                    </BootstrapTooltip>
                  </TableCell>

                  <TableCell className={`${styles.TableBodyText} ${styles.Nowrap}`}>
                    {item?.property_name ? item?.property_name : "-"}
                  </TableCell>
                  <TableCell className={`${styles.TableBodyText} ${styles.Nowrap}`}>
                    {item?.apt_no ? item?.apt_no : "-"}
                  </TableCell>
                  <TableCell className={`${styles.TableBodyText} ${styles.Nowrap}`}>
                    {moment.utc(item?.submitted_at).fromNow()}
                    {item?.approval_remaining_days !== null && (item?.current_status !== 3 && item?.current_status !== 4) && <BootstrapTooltip title={(<div className={`${styles.IncomeLineTooltip}`}>
                      {item?.approval_remaining_days > 0 && <p>{item?.approval_remaining_days > 1 ? item?.approval_remaining_days + ' days ' : item?.approval_remaining_days + ' day '}remaining for approval.</p>}
                      {item?.approval_remaining_days <= 0 && <p>Approval Overdue ({Math.abs(item?.approval_remaining_days) + 1} days)</p>}
                    </div>)}>
                      <span className={`${styles.ProspectOverdueBadge}`}><AlertCircle /></span>
                    </BootstrapTooltip>}
                  </TableCell>
                </TableRow>
              </div>);
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  </>);
};

export default ListRecords;